export const FISCAL_PARAMETRIZATION_VIEW_ROLES = [
  'TENANT_ADMIN',
  'FISCAL_ADMIN',
  'FISCAL_VIEW',
] as const;

export const FISCAL_PARAMETRIZATION_MUTATION_ROLES = ['TENANT_ADMIN', 'FISCAL_ADMIN'] as const;

export const FISCAL_EMIT_ROLES = ['TENANT_ADMIN', 'FISCAL_EMIT'] as const;

export function canViewFiscalParametrization(roles: readonly string[]): boolean {
  return roles.some((role) =>
    (FISCAL_PARAMETRIZATION_VIEW_ROLES as readonly string[]).includes(role),
  );
}

export function canMutateFiscalParametrization(roles: readonly string[]): boolean {
  return roles.some((role) =>
    (FISCAL_PARAMETRIZATION_MUTATION_ROLES as readonly string[]).includes(role),
  );
}

/** BR-FIS-57 — issue stub: TENANT_ADMIN or FISCAL_EMIT */
export function canEmitFiscalDocument(roles: readonly string[]): boolean {
  return roles.some((role) => (FISCAL_EMIT_ROLES as readonly string[]).includes(role));
}
